import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { DownloadInvoice, GetOrderDetailsById } from "../Services/MainServices";
import { toast } from "react-toastify";

export const useOrderDetails = () => {
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await GetOrderDetailsById(orderId);
      if (res?.data?.status == "success") {
        setOrderDetails(res.data.data);
      } else {
        throw new Error("Failed to get order details.");
      }
    } catch (err) {
      setError(err.message ?? "Failed to get order details");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { orderDetails, loading, error, refetch: fetchData };
};

export const useDownloadInvoice = () => {
  const { orderId } = useParams();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await DownloadInvoice(orderId);
      if (res?.data?.status == "success") {
        return res.data.data;
      } else {
        throw new Error("Failed to get invoice.");
      }
    } catch (err) {
      toast.error("Failed to get invoice.");
    } finally {
      setLoading(false);
    }
  }, []);

  return { getInvoice: fetchData, loading };
};
